import { render } from "./TheBoolean.vue?vue&type=template&id=91635b06&scoped=true"
const script = {}

import "@/assets/styles/boolean.scss?vue&type=style&index=0&id=91635b06&lang=scss&scoped=true"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91635b06"]])

export default __exports__